var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    `cv-structured-list-data ${_vm.carbonPrefix}--structured-list-td`,
    {
      [`${_vm.carbonPrefix}--structured-list-content--nowrap`]: _vm.noWrap,
    },
  ]},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }